import Vue from "vue";
import { colors } from "vuetify/lib";

const getDefaultState = () => {
  return {
    listeRegionsSupervisees: [],
    listeDistrictsDuSuperviseur: [],
    actual_month: "",
    previous_month: "",
    previous_month2: "",
    previous_month3: "",
    previous_month4: "",
    previous_month5: "",
    annee_actuelle: "",
    groupesLoaded: false,
    membresLoaded: false,
    menagesLoaded: false,
    campagnesLoaded: false,
    formationsLoaded: false,
    dotationsLoaded: false,
    formationsDeMasseLoaded: false,
    paramsLoaded: false,
    localStorageSize: 0,
  };
};
const state = getDefaultState();

const mutations = {
  SET_LISTE_REGION_SUPERVISEES(state, payload) {
    console.log("SET_LISTE_REGION_SUPERVISEES: ", payload);
    state.listeRegionsSupervisees = payload;
    this.commit("Groupes/SET_GROUPES_DE_REGIONS_SCROLL", [], { root: true });
    this.commit("Groupes/SET_START_SCROLL", null, { root: true });
  },
  SET_LISTE_DISTRICTS_DE_ANIMATEUR(state, payload) {
    console.log("SET_LISTE_DISTRICTS_DE_ANIMATEUR: ", payload);
    state.listeDistrictsDuSuperviseur = payload;
  },
  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  },
  SET_ANNEE_ACTUELLE(state) {
    var annee_actuelle = this._vm.$moment().format("YYYY");
    state.annee_actuelle = annee_actuelle;
    state.actual_month = this._vm.$moment().format("YYYY-MM-DD");
    state.previous_month = this._vm
      .$moment()
      .subtract(1, "months")
      .format("YYYY-MM-DD");
    state.previous_month2 = this._vm
      .$moment()
      .subtract(2, "months")
      .format("YYYY-MM-DD");
    state.previous_month3 = this._vm
      .$moment()
      .subtract(3, "months")
      .format("YYYY-MM-DD");
    state.previous_month4 = this._vm
      .$moment()
      .subtract(4, "months")
      .format("YYYY-MM-DD");
    state.previous_month5 = this._vm
      .$moment()
      .subtract(5, "months")
      .format("YYYY-MM-DD");
  },
  SET_LOADED(state, payload) {
    state[payload] = true;
  },
  SET_LOCAL_STORAGE_SIZE(state, payload) {
    state.localStorageSize = payload;
  },

  RESET_LOADED(state) {
    state.groupesLoaded = false;
    state.membresLoaded = false;
    state.menagesLoaded = false;
    state.campagnesLoaded = false;
    state.formationsLoaded = false;
    state.dotationsLoaded = false;
    state.formationsDeMasseLoaded = false;
    state.paramsLoaded = false;
  },
};

const actions = {
  set_annee_actuelle({ commit, dispatch }) {
    commit("SET_ANNEE_ACTUELLE");
  },
  setLocalStorageSize({ commit }) {
    var allStrings = "";
    for (var key in window.localStorage) {
      allStrings += key;
      if (window.localStorage.hasOwnProperty(key)) {
        allStrings += window.localStorage[key];
      }
    }
    var size = allStrings
      ? 3 + Math.round((allStrings.length * 16) / (8 * 1024)) + " KB"
      : "Empty (0 KB)";

    commit("SET_LOCAL_STORAGE_SIZE", size);
  },
  markLoaded({ commit, dispatch }, objet) {
    console.log(objet.type);
    commit("SET_LOADED", objet.type);
    dispatch("setLocalStorageSize");
  },
  markUnLoaded({ commit, dispatch }) {
    commit("RESET_LOADED");
    dispatch("setLocalStorageSize");
  },

  resetState({ commit }) {
    commit("RESET_STATE");
  },
  clearAllStores({ dispatch }) {
    dispatch("Activites/resetState", "Logout", {
      root: true,
    });
    dispatch("Bailleurs/resetState", "Logout", {
      root: true,
    });
    dispatch("Campagnes/resetState", "Logout", {
      root: true,
    });
    dispatch("EtapeEffective/resetState", "Logout", {
      root: true,
    });
    dispatch("Projets/resetState", "Logout", {
      root: true,
    });
    dispatch("Users/resetState", "Logout", {
      root: true,
    });
    dispatch("Membres/resetState", "Logout", {
      root: true,
    });
    dispatch("DotationsDeGroupe/resetState", "Logout", {
      root: true,
    });
    dispatch("FormationsDeGroupe/resetState", "Logout", {
      root: true,
    });
    dispatch("Groupes/resetState", "Logout", {
      root: true,
    });
    dispatch("HorsGroupe/resetState", "Logout", {
      root: true,
    });
    dispatch("Utils/resetState", "Logout", {
      root: true,
    });
    dispatch("Fiches/resetState", "Logout", {
      root: true,
    });
    dispatch("Mygroupes/resetState", "Logout", {
      root: true,
    });
    dispatch("Fokontany/resetState", "Logout", {
      root: true,
    });
    dispatch("Communes/resetState", "Logout", {
      root: true,
    });
    dispatch("Campagnes/resetState", "Logout", {
      root: true,
    });
    dispatch("ParcoursEffectif/resetState", "Logout", {
      root: true,
    });
    dispatch("DetailEtapes/resetState", "Logout", {
      root: true,
    });
    dispatch("Districts/resetState", "Logout", {
      root: true,
    });
    dispatch("Etapes/resetState", "Logout", {
      root: true,
    });
    dispatch("Menages/resetState", "Logout", {
      root: true,
    });
    dispatch("PresencesFormationsDeGroupe/resetState", "Logout", {
      root: true,
    });
    dispatch("PresencesDotationsDeGroupe/resetState", "Logout", {
      root: true,
    });

    dispatch("FormationsDeMasse/resetState", "Logout", {
      root: true,
    });
    dispatch("Utils/resetState", "Logout", {
      root: true,
    });
    dispatch("Auth/resetState", "Logout", {
      root: true,
    });
  },
  GetArrayRegions({ commit }, superviseur) {
    this._vm.$vloading.show();
    const listeRegions = [];
    const regionsSupervisees = Array.isArray(superviseur.regionsSupervisees)
      ? superviseur.regionsSupervisees
      : [];
    _.forEach(regionsSupervisees, function (item, index) {
      listeRegions[index] = item.id;
    });
    commit("SET_LISTE_REGION_SUPERVISEES", listeRegions);
    this._vm.$vloading.hide();
  },
  GetDistrictsDuSuperviseur({ commit }, superviseur) {
    //console.log("GetDistrictsDuSuperviseur: ",superviseur);
    this._vm.$vloading.show();

    commit("SET_LISTE_DISTRICTS_DE_ANIMATEUR", []);
    let districtsDuSuperviseur = Array.isArray(superviseur.districts)
      ? superviseur.districts
      : [];
    commit("SET_LISTE_DISTRICTS_DE_ANIMATEUR", districtsDuSuperviseur);
    this._vm.$vloading.hide();
  },

  //generate menage
  generateMenages({ commit, dispatch }, objet) {
    var self = this;
    this._vm.$vloading.show();
    var membresTemp = [];
    var membresNoCodeTemp = [];
    var menages = [];
    objet.MembresDugroupe.forEach(function (membre) {
      if (membre.code_menage) {
        membresTemp.push(membre);

        //create menage from code menage
        var objetMenage = membre;
        objetMenage.nomMembrePrincipal = membre.nom;
        delete objetMenage.actif_dans_groupe;
        delete objetMenage.annee_naissance;
        delete objetMenage.date_insert_membre;
        delete objetMenage.membre_gec;
        delete objetMenage.nom;
        delete objetMenage.raison_inactivite;
        delete objetMenage.sexe;
        objetMenage.dateGenerationMenage = self._vm
          .$moment(Date.now())
          .format("YYYY-MM-DD HH:mm:ss");
        objetMenage.projectList = objet.groupe.projectList;
        objetMenage.projets = objet.groupe.projets;
        //code_menage
        objetMenage.id = membre.code_menage;
        objetMenage.ll_menage = membre.code_menage;
        menages.push(objetMenage);
        dispatch("insertMenage", objetMenage);
      } else {
        //create menage
        let newMenageId = self._vm.$uuid.v4();
        membresNoCodeTemp.push(membre);
        var oldmbId = membre.id;

        var objetMenage = membre;
        objetMenage.nomMembrePrincipal = membre.nom;
        delete objetMenage.actif_dans_groupe;
        delete objetMenage.annee_naissance;
        delete objetMenage.date_insert_membre;
        delete objetMenage.membre_gec;
        delete objetMenage.nom;
        delete objetMenage.raison_inactivite;
        delete objetMenage.sexe;
        objetMenage.dateGenerationMenage = self._vm
          .$moment(Date.now())
          .format("YYYY-MM-DD HH:mm:ss");
        objetMenage.projectList = objet.groupe.projectList;
        objetMenage.projets = objet.groupe.projets;
        //code_menage
        objetMenage.id = newMenageId;
        objetMenage.ll_menage = newMenageId;
        menages.push(objetMenage);
        dispatch("insertMenage", objetMenage);
        var ob2 = { idMembre: oldmbId, idMenage: newMenageId };

        dispatch("createAndInsertMenageToMembre", ob2);
      }
    });
    //end menage
    var ob3 = { idGroupe: objet.groupe.id };
    dispatch("markGroupeAsMenageGenarated", ob3);
    this._vm.$vloading.hide();
  },

  getSexe(sexe) {
    if (sexe == "1" || sexe == 1) {
      return "Masculin";
    } else if (sexe == "0" || sexe == 2) {
      return "Féminin";
    } else {
      return "Nan";
    }
  },

  insertMenage({ commit, dispatch }, newMenage) {
    console.log("newMenage", newMenage);
    let self = this;
    this._vm.$firebase
      .firestore()
      .collection("newMenages")
      .doc(newMenage.id)
      .set(newMenage, { merge: true })
      .then(() => {
        console.log("New menage :" + newMenage.id + " successfully written!");
        self.loading = false;
      })
      .catch((error) => {
        console.error("Error writing document: ", error);
        self.loading = false;
      });

    dispatch("Menages/addOneItem", newMenage, {
      root: true,
    });
  },
  markGroupeAsMenageGenarated({ commit, dispatch }, ob3) {
    let self = this;
    this._vm.$firebase
      .firestore()
      .collection("groupes")
      .doc(ob3.idGroupe)
      .set({ menageGenerated: true }, { merge: true })
      .then(() => {
        console.log("Group marked menageGenerated!");
      })
      .catch((error) => {
        console.error("Error writing document: ", error);
      });
  },
  createAndInsertMenageToMembre({ commit, dispatch }, objet) {
    console.log("createAndInsertMenageToMembre", objet);
    var ref = this._vm.$firebase
      .firestore()
      .collection("membres")
      .doc(objet.idMembre);

    ref
      .set(
        {
          code_menage: objet.idMenage,
        },
        { merge: true }
      )
      .then((docRef) => {
        console.log("Document updated");
      })
      .catch((error) => {
        console.error("Error updating document: ", error);
      });
  },

  //end generate menage
};

const getters = {
  listeRegionsSupervisees: (state) => {
    return state.listeRegionsSupervisees;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
